/**
 * Eddie Borgo — Curated Products Mobile Slider
 *
 * Converts the product grid into a horizontal slider on mobile.
 * Uses CSS scroll-snap for native smooth scrolling.
 * IntersectionObserver updates the active dot.
 * Dot click scrolls to the corresponding product.
 */
(function () {
  'use strict';

  var MOBILE_BP = 601;

  function initSliders() {
    var grids = document.querySelectorAll('[data-eb-slider="true"]');
    grids.forEach(function (grid) {
      if (grid._ebSliderInit) return;
      grid._ebSliderInit = true;
      new CuratedSlider(grid);
    });
  }

  function CuratedSlider(grid) {
    this.grid = grid;
    this.dotsWrap = grid.parentElement.querySelector('.eb-curated__dots');
    this.cards = grid.querySelectorAll('.eb-curated-card');
    this.dots = [];
    this.observer = null;
    this.active = 0;

    if (!this.dotsWrap || this.cards.length < 2) return;

    this.buildDots();
    this.check = this.check.bind(this);
    this.check();
    window.addEventListener('resize', this.check);
  }

  CuratedSlider.prototype.buildDots = function () {
    var self = this;
    this.dotsWrap.innerHTML = '';
    this.dots = [];

    for (var i = 0; i < this.cards.length; i++) {
      var dot = document.createElement('li');
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-index'), 10);
        self.goTo(idx);
      });
      this.dotsWrap.appendChild(dot);
      this.dots.push(dot);
    }
  };

  CuratedSlider.prototype.check = function () {
    if (window.innerWidth < MOBILE_BP) {
      this.activate();
    } else {
      this.deactivate();
    }
  };

  CuratedSlider.prototype.activate = function () {
    if (this.grid.hasAttribute('data-eb-slider-active')) return;
    this.grid.setAttribute('data-eb-slider-active', '');
    this.connectObserver();
  };

  CuratedSlider.prototype.deactivate = function () {
    if (!this.grid.hasAttribute('data-eb-slider-active')) return;
    this.grid.removeAttribute('data-eb-slider-active');
    this.disconnectObserver();
  };

  CuratedSlider.prototype.connectObserver = function () {
    var self = this;
    this.disconnectObserver();

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(self.cards, entry.target);
          if (idx >= 0) self.setActive(idx);
        }
      });
    }, {
      root: this.grid,
      threshold: 0.6
    });

    this.cards.forEach(function (card) {
      self.observer.observe(card);
    });
  };

  CuratedSlider.prototype.disconnectObserver = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  };

  CuratedSlider.prototype.setActive = function (idx) {
    if (idx === this.active) return;
    this.active = idx;
    for (var i = 0; i < this.dots.length; i++) {
      this.dots[i].classList.toggle('active', i === idx);
    }
  };

  CuratedSlider.prototype.goTo = function (idx) {
    if (idx < 0 || idx >= this.cards.length) return;
    this.cards[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
